module.exports = __webpack_public_path__ + "static/media/1@2x.50b193e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/1@2x.png
// module id = 372
// module chunks = 0